import NavBar from "../../components/NavBar";
import { List, Avatar, Picker } from "antd-mobile";

import "./index.scss";
import { useNavigate } from "react-router-dom";
import useGlobal from "../../hooks/useGlobal";
import { hideAccount } from "../../utils/utils";
import { useState } from "react";
import { useEffect } from "react";
import { getLevel } from "../../api";
import useWallet from "../../hooks/Wallet/useWallet";
import { useIntl } from "react-intl";
import useCommon from "../../hooks/Common/useCommon";
import useLayout from "../../hooks/Layout/useLayout";
export default function User() {
  const handleClick = () => {};
  const {navigateTo} = useLayout()
  const { inviter, userInfo } = useGlobal();
  const { myAccount } = useWallet();
  const [distance, setDistance] = useState(0);

  const [level, setLevel] = useState(0);
  const { lang, changeLang } = useCommon();
  const intl = useIntl();
  useEffect(() => {
    if (userInfo) {
      init();
    }
  }, [userInfo]);
  const columns = [
    [
      { label: "中文", value: "zh" },
      { label: "Engish", value: "en" },
    ],
  ];

  const init = async () => {
    const t = Math.floor(((userInfo.steps * 0.7) / 1000) * 100) / 100;
    setDistance(t);
    const res_level = await getLevel(myAccount.account);
    setLevel(res_level.data);
  };

  return (
    <>
      <NavBar
        title={intl.formatMessage({
          id: "pages.user.title",
          defaultMessage: "设置",
        })}
      />
      <List className="user_list avatar">
        <List.Item
          prefix={<Avatar src={"/image/default_avatar.png"} />}
          description="runbiter@email.com"
          onClick={() => {
            navigateTo("/user/center", '/user');
          }}
        >
          runbiter
        </List.Item>
      </List>
      <List className="user_list mt-50 normal">
        <List.Item
          extra={hideAccount(inviter)}
          onClick={() => {
            navigateTo("/invite", '/user');
          }}
        >
          {intl.formatMessage({
            id: "pages.user.inviter",
            defaultMessage: "推荐人",
          })}
        </List.Item>
        <List.Item extra={distance||''} onClick={() => {}}>
          {intl.formatMessage({
            id: "pages.user.distance",
            defaultMessage: "總距離",
          })}
        </List.Item>
        <List.Item
          extra={"Lv" + level}
          onClick={() => {
            navigateTo("/level",'/user');
          }}
        >
          {intl.formatMessage({
            id: "pages.user.level",
            defaultMessage: "級別",
          })}
        </List.Item>
        <List.Item extra="Polygon" onClick={handleClick}>
          {intl.formatMessage({
            id: "pages.user.chain",
            defaultMessage: "區塊鏈",
          })}
        </List.Item>
        <Picker
          columns={columns}
          confirmText={intl.formatMessage({
            id: "common.confrim",
            defaultMessage: "確定",
          })}
          cancelText={intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          })}
          value={[lang || "zh"]}
          onConfirm={(v, e) => {
            changeLang(v[0]);
          }}
        >
          {(items, { open }) => (
            <List.Item
              extra={
                items.every((item) => item === null)
                  ? "未选择"
                  : items.map((item) => item?.label ?? "未选择").join(" - ")
              }
              onClick={open}
            >
              {intl.formatMessage({
                id: "pages.user.language",
                defaultMessage: "语言",
              })}
            </List.Item>
          )}
        </Picker>

        <List.Item extra="2.0" onClick={handleClick}>
          {intl.formatMessage({
            id: "pages.user.version",
            defaultMessage: "版本",
          })}
        </List.Item>
        <List.Item
          onClick={() => {
            if(lang === 'zh') {

            navigateTo("/help",'/user');
            }else {

              navigateTo("/help/en",'/user');
            }
          }}
        >
          {intl.formatMessage({
            id: "pages.user.hlep",
            defaultMessage: "幫助",
          })}
        </List.Item>
      </List>
    </>
  );
}
